import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useMoveSubDealToAnotherSubCampaign = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const moveSubDealToAnotherSubCampaign = async (params = {}) => {
        setLoading(true);
        setError(null);

        const { profileId, removedSubCampaignId, movedSubCampaignId, movedMasterCampaignId, dealId } = params;

        if (!profileId || !removedSubCampaignId || !movedSubCampaignId || !movedMasterCampaignId || !dealId) {
            const errorMessage = "Missing required parameters";
            setError(errorMessage);
            setLoading(false);
            toast.error(errorMessage);
            return { error: errorMessage };
        }

        const payload = {
            fn: "moveSubDealToAnotherSubCampaign",
            profileId,
            removedSubCampaignId,
            movedSubCampaignId,
            movedMasterCampaignId,
            dealId,
        };

        try {
            const response = await post(payload);
            toast.success("Sub deal moved successfully");
            return { data: response.data };
        } catch (error) {
            const errorMessage = apiErrorText(error);
            setError(errorMessage);
            toast.error(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { moveSubDealToAnotherSubCampaign, loading, error };
};

export default useMoveSubDealToAnotherSubCampaign;
